"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onChartRendered = exports.CHART_RENDERED = void 0;
exports.CHART_RENDERED = 'CHART_RENDERED';
function onChartRendered() {
    return { type: exports.CHART_RENDERED };
}
exports.onChartRendered = onChartRendered;
//# sourceMappingURL=chart.js.map